const state = {
  gameEndData: null,
};

const getters = {
  getGameEndData(state) {
    return state.gameEndData;
  },
};

const actions = {
  emitGameEnd({ commit }) {
    const url = window.location.href;
    const idStartIndex = url.indexOf('game/') + 5;
    let idEndIndex = url.indexOf('?');
    idEndIndex = idEndIndex !== -1 ? idEndIndex : window.location.href.length;
    const gameId = +url.substring(idStartIndex, idEndIndex);
    commit('EMIT_GAME_END', { gameId, event: 'GAME_END', message: 'game over' });
  },
};

const mutations = {
  EMIT_GAME_END(state, data) {
    state.gameEndData = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
